// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import TermsConditionsDEPage from "../pages/TermsConditionsDE/TermsConditionsDE";
const __wvcRoutePaths = ["/TermsConditionsDEPage", "/terms-conditions-de"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "ausflug-zum-mini-egypt-park", "book-transfer", "book-transfer-ar", "book-transfer-de", "booktransferarpage", "booktransferdepage", "bookyourprivatetransferpage", "buggy-safari", "buggy-safari-ar", "buggysafari2page", "buggysafariarpage", "buggysafaripage", "cairo-pyramids-day-tour-ar", "cairopyramidsdaytourarpage", "cairopyramidsdaytourpage", "cookies-policy", "cookies-policy-ar", "cookies-policy-de", "cookiespolicyarpage", "cookiespolicydepage", "cookiespolicypage", "day-trips", "daytripspage", "daytriptocairoandpyramidspage", "daytriptoluxorpage", "delfinschwimmen-bei-dolphin-world", "delfinshow", "destinations", "destinations-ar", "destinations-de", "destinationsarpage", "destinationsdepage", "destinationspage", "diving-boat-trip", "diving-boat-trip-ar", "divingboattriparpage", "divingboattrippage", "dolphin-show", "dolphin-world-show-ar", "dolphinworlddolphinshowpage", "dolphinworldshowarpage", "dolphinworldshowpage", "dolphinworldswimmingpage", "help-center", "help-center-ar", "help-center-de", "helpcenterarpage", "helpcenterdepage", "helpcenterpage", "home", "home-ar", "home-de", "homearpage", "homedepage", "homepage", "horse-riding-trip", "horse-riding-trip-ar", "horseridingtriparpage", "horseridingtripinhurghadapage", "horseridingtrippage", "hurghada-highlights-city-tour", "hurghada-highlights-city-tour-ar", "hurghadacitytourpage", "hurghadahighlightscitytourarpage", "hurghadahighlightscitytourpage", "lakeboattrippage", "luxor-day-tour-ar", "luxordaytourarpage", "luxordaytourpage", "mini-egypt-park-tour", "mini-egypt-park-tour-ar", "miniegyptparktourarpage", "miniegyptparktourpage", "miniegyptparktrippage", "orange-bay-insel-ausflug", "orange-bay-island-trip", "orange-bay-island-trip-ar", "orangebayislandexcursionpage", "orangebayislandtriparpage", "orangebayislandtrippage", "paradise-island-ausflug", "paradise-island-trip", "paradise-island-trip-ar", "paradiseislandtrip2page", "paradiseislandtriparpage", "paradiseislandtrippage", "parasailing", "parasailing-ar", "parasailing-in-hurghada", "parasailingarpage", "parasailinginhurghadapage", "parasailingpage", "post", "privacy-policy", "privacy-policy-ar", "privacy-policy-de", "privacypolicyarpage", "privacypolicydepage", "privacypolicypage", "private-cairo-tour-from-hurghada", "private-driver-hire", "private-driver-hire-ar", "private-driver-hire-de", "private-kairo-tour-ab-hurghada", "private-luxor-tour-ab-hurghada", "private-luxor-tour-from-hurghada", "private-speedboat-trip", "private-speedboat-trip-ar", "private-speedboot-tour", "privatedriverhirearpage", "privatedriverhiredepage", "privatedriverhirepage", "privatespeedboattriparpage", "privatespeedboattrippage", "privatespeedboottourpage", "quad-bike-safari", "quad-bike-safari-ar", "quad-bike-safari-in-hurghada", "quadbikesafariarpage", "quadbikesafaripage", "quadsafariinhurghadapage", "reitausflug-in-hurghada", "reitausflug-zwischen-meer-und-wustenlandschaft", "sea-mountain-horse-riding", "sea-mountain-horse-riding-ar", "sea-scope-halb-u-boot", "sea-scope-semi-submarine", "seaanddesertridepage", "seamountainhorseridingarpage", "seamountainhorseridingpage", "search", "seascoperedseatrippage", "semi-submarine-red-sea-trip-ar", "semisubmarineredseatriparpage", "semisubmarineredseatrippage", "stadtrundfahrt-durch-hurghada", "super-safari-abenteuer", "super-safari-adventure", "super-safari-adventure-ar", "supersafariadventure2page", "supersafariadventurearpage", "supersafariadventurepage", "swimming-with-dolphins-at-dolphin-world", "swimming-with-dolphins-at-dolphin-world-ar", "swimmingwithdolphinsatdolphinworldarpage", "swimmingwithdolphinsatdolphinworldpage", "tauchausflug-mit-dem-boot", "taxi-service", "taxi-service-ar", "taxi-service-de", "taxiservicearpage", "taxiservicedepage", "taxiservicepage", "terms-conditions", "terms-conditions-ar", "terms-conditions-de", "termsconditionsarpage", "termsconditionsdepage", "termsconditionspage", "tours-excursions", "tours-excursions-ar", "tours-excursions-de", "toursexcursionsarpage", "toursexcursionsdepage", "toursexcursionspage", "travel-guides", "travel-guides-de", "travelguidesdepage", "travelguidespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<TermsConditionsDEPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<TermsConditionsDEPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
